export default __webpack_public_path__ + "static/media/services_photography.0732ef32.jpg";